(() => {
  const integrationKey = 'createIt3DBoostSearchKeyboardV1';
  if (window[integrationKey]) return;
  window[integrationKey] = true;

  const inputSelector = '.boost-sd__search-widget-init-input';
  const wrapperSelector = '#boost-sd__search-widget-init-wrapper';
  let wrapperObserver;
  let observedWrapper;
  let keyboardIndex = -1;
  let keyboardHref = '';

  const visibleLinks = (wrapper) =>
    Array.from(wrapper?.querySelectorAll('a[href]') || []).filter(
      (link) => link.getClientRects().length > 0
    );

  const clearKeyboardSelection = (input) => {
    keyboardIndex = -1;
    keyboardHref = '';
    input?.removeAttribute('aria-activedescendant');
    document
      .querySelectorAll(`${wrapperSelector} a[data-createit-search-active]`)
      .forEach((link) => {
        link.removeAttribute('data-createit-search-active');
        link.style.removeProperty('outline');
        link.style.removeProperty('outline-offset');
        link.style.removeProperty('border-radius');
      });
  };

  const moveKeyboardSelection = (input, direction) => {
    const wrapper = document.querySelector(wrapperSelector);
    const links = visibleLinks(wrapper);
    if (!links.length) return false;

    links.forEach((link) => {
      link.removeAttribute('data-createit-search-active');
      link.style.removeProperty('outline');
      link.style.removeProperty('outline-offset');
      link.style.removeProperty('border-radius');
    });

    if (keyboardIndex < 0) {
      keyboardIndex = direction > 0 ? 0 : links.length - 1;
    } else {
      keyboardIndex =
        (keyboardIndex + direction + links.length) % links.length;
    }

    const selectedLink = links[keyboardIndex];
    if (!selectedLink.id) {
      selectedLink.id = `createit3d-search-option-${keyboardIndex}`;
    }
    selectedLink.setAttribute('data-createit-search-active', 'true');
    selectedLink.style.outline = '2px solid #262626';
    selectedLink.style.outlineOffset = '2px';
    selectedLink.style.borderRadius = '8px';
    selectedLink.scrollIntoView({ block: 'nearest' });
    keyboardHref = selectedLink.href;
    input.setAttribute('aria-expanded', 'true');
    input.setAttribute('aria-activedescendant', selectedLink.id);
    return true;
  };

  const syncExpandedState = (input) => {
    const wrapper = document.querySelector(wrapperSelector);
    const hasFocus =
      document.activeElement === input || wrapper?.contains(document.activeElement);
    const isOpen =
      hasFocus &&
      wrapper &&
      getComputedStyle(wrapper).display !== 'none' &&
      visibleLinks(wrapper).length > 0;

    input.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    if (!isOpen) input.removeAttribute('aria-activedescendant');
  };

  const observeWrapper = (input) => {
    const wrapper = document.querySelector(wrapperSelector);
    if (!wrapper || wrapper === observedWrapper) return;

    wrapperObserver?.disconnect();
    observedWrapper = wrapper;
    wrapperObserver = new MutationObserver(() => syncExpandedState(input));
    wrapperObserver.observe(wrapper, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ['class', 'style']
    });
  };

  const queueExpandedSync = (input) => {
    observeWrapper(input);
    [0, 250, 750].forEach((delay) => {
      window.setTimeout(() => syncExpandedState(input), delay);
    });
  };

  document.addEventListener(
    'input',
    (event) => {
      const input = event.target.closest?.(inputSelector);
      if (input) {
        clearKeyboardSelection(input);
        queueExpandedSync(input);
      }
    },
    true
  );

  document.addEventListener(
    'focusin',
    (event) => {
      const input = event.target.closest?.(inputSelector);
      if (input) queueExpandedSync(input);
    },
    true
  );

  document.addEventListener(
    'focusout',
    (event) => {
      const input = event.target.closest?.(inputSelector);
      if (!input) return;
      window.setTimeout(() => syncExpandedState(input), 0);
    },
    true
  );

  window.addEventListener(
    'keydown',
    (event) => {
      const input = event.target.closest?.(inputSelector);
      if (!input) return;

      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        const direction = event.key === 'ArrowDown' ? 1 : -1;
        if (!moveKeyboardSelection(input, direction)) return;
        event.preventDefault();
        event.stopImmediatePropagation();
      } else if (event.key === 'Enter') {
        const query = input.value.trim();
        if (!query) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        const root = window.Shopify?.routes?.root || '/';
        window.location.assign(
          keyboardHref || `${root}search?q=${encodeURIComponent(query)}`
        );
      } else if (event.key === 'Escape') {
        event.preventDefault();
        event.stopImmediatePropagation();
        clearKeyboardSelection(input);
        input.setAttribute('aria-expanded', 'false');
        input.blur();
      }
    },
    true
  );

  /* Collection cards are links inside draggable Swiper tracks. Mark their
     visible copy as a no-swipe target so a drag selects text instead of moving
     the carousel, then suppress only the link click produced by that selection. */
  const copyFriendlyCardTextSelector =
    '.collection-card__title, .ci3d-collection-card__cue';

  const prepareCopyFriendlyCards = (root = document) => {
    root.querySelectorAll(copyFriendlyCardTextSelector).forEach((element) => {
      element.classList.add('swiper-no-swiping');
      element.closest('.collection-card__wrapper')?.setAttribute('draggable', 'false');
    });
  };

  prepareCopyFriendlyCards();
  document.addEventListener('shopify:section:load', (event) => {
    prepareCopyFriendlyCards(event.target);
  });

  document.addEventListener(
    'dragstart',
    (event) => {
      if (event.target.closest?.(copyFriendlyCardTextSelector)) {
        event.preventDefault();
      }
    },
    true
  );

  document.addEventListener(
    'click',
    (event) => {
      if (!event.target.closest?.(copyFriendlyCardTextSelector)) return;
      const selectedText = window.getSelection?.().toString().trim();
      if (!selectedText) return;

      event.preventDefault();
      event.stopPropagation();
    },
    true
  );

  const salesEmailAddress = 'sales@createit3d.co.za';
  const salesEmailHref =
    'mailto:sales@createit3d.co.za?subject=Create%20It%203D%20sales%20enquiry';

  const createSalesEmailLink = (className, label) => {
    const link = document.createElement('a');
    link.className = className;
    link.href = salesEmailHref;
    link.setAttribute(
      'aria-label',
      `Email Create It 3D sales at ${salesEmailAddress}`
    );

    const icon = document.createElement('span');
    icon.className = 'material-symbols-rounded';
    icon.setAttribute('aria-hidden', 'true');
    icon.textContent = 'mail';

    const text = document.createElement('span');
    text.textContent = label;

    link.append(icon, text);
    return link;
  };

  const ensureSalesEmailVisibility = () => {
    const utility = document.querySelector('.ci3d-v2-header__utility');
    if (utility && !utility.querySelector('.ci3d-v2-header__sales-email')) {
      const utilityLink = createSalesEmailLink(
        'ci3d-v2-header__sales-email',
        `Sales: ${salesEmailAddress}`
      );
      utility.prepend(utilityLink);
    }

    const mobileContact = document.querySelector(
      '.ci3d-v2-header__mobile-ai'
    );
    if (
      mobileContact &&
      !document.querySelector('.ci3d-v2-header__mobile-sales-email')
    ) {
      const mobileLink = createSalesEmailLink(
        'ci3d-v2-header__mobile-sales-email',
        `Email ${salesEmailAddress}`
      );
      mobileContact.insertAdjacentElement('afterend', mobileLink);
    }

    const footerBrand = document.querySelector('.ci3d-v2-footer__brand');
    if (footerBrand && !footerBrand.querySelector('.ci3d-v2-footer__sales-email')) {
      const footerLink = createSalesEmailLink(
        'ci3d-v2-footer__sales-email',
        `Sales enquiries: ${salesEmailAddress}`
      );
      const regionalLinks = footerBrand.querySelector(
        '.ci3d-v2-footer__regional'
      );
      footerBrand.insertBefore(footerLink, regionalLinks);
    }
  };

  ensureSalesEmailVisibility();
  document.addEventListener('shopify:section:load', ensureSalesEmailVisibility);
})();
